import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import translations from '../translations';
import ImpressumModal from './ImpressumModal';
import DatenschutzModal from './DatenschutzModal';

const FooterSection = styled.footer`
  padding: 80px 0 30px;
  background-color: ${props => props.theme === 'dark' ? '#121212' : '#f8f9fa'};
  position: relative;
`;

const FooterContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 40px;
  margin-bottom: 60px;
  
  @media (min-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 992px) {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
`;

const FooterColumn = styled.div``;

const FooterLogo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${props => props.theme === 'dark' ? '#f8f9fa' : '#333'};
  margin-bottom: 20px;
`;

const FooterDescription = styled.p`
  font-size: 1rem;
  color: ${props => props.theme === 'dark' ? '#ced4da' : '#6c757d'};
  line-height: 1.6;
  margin-bottom: 25px;
`;

const FooterTitle = styled.h3`
  font-size: 1.1rem;
  color: ${props => props.theme === 'dark' ? '#f8f9fa' : '#333'};
  margin-bottom: 20px;
  font-weight: 600;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 12px;
  
  a {
    font-size: 1rem;
    color: ${props => props.theme === 'dark' ? '#ced4da' : '#6c757d'};
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      color: #4a6cf7;
      padding-left: 5px;
    }
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
  border-top: 1px solid ${props => props.theme === 'dark' ? '#343a40' : '#e9ecef'};
  
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  color: ${props => props.theme === 'dark' ? '#ced4da' : '#6c757d'};
  margin-bottom: 20px;
  
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const FooterBottomLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const FooterBottomLink = styled.a`
  font-size: 0.9rem;
  color: ${props => props.theme === 'dark' ? '#ced4da' : '#6c757d'};
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    color: #4a6cf7;
  }
`;

const Footer = ({ theme }) => {
  const { language } = useLanguage();
  const t = translations.footer[language];
  const currentYear = new Date().getFullYear();
  const [impressumOpen, setImpressumOpen] = React.useState(false);
  const [datenschutzOpen, setDatenschutzOpen] = React.useState(false);

  return (
    <FooterSection theme={theme}>
      <FooterContainer>
        <FooterTop>
          <FooterColumn>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <FooterLogo theme={theme}>Explainable AI Solutions</FooterLogo>
              <FooterDescription theme={theme}>
                {t.description}
              </FooterDescription>
              {/* SocialLinks entfernt */}
            </motion.div>
          </FooterColumn>
          {/* Vertikale Menüstrukturen entfernt */}
        </FooterTop>

        <FooterBottom>
          <Copyright theme={theme}>
            {currentYear} Explainable AI Solutions. {t.copyright}
          </Copyright>
          <FooterBottomLinks>
            <FooterBottomLink as="button" onClick={() => setImpressumOpen(true)} theme={theme} style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>Impressum</FooterBottomLink>
            <FooterBottomLink as="button" onClick={() => setDatenschutzOpen(true)} theme={theme} style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>{t.privacyNotice}</FooterBottomLink>
          </FooterBottomLinks>
        </FooterBottom>
      </FooterContainer>
      <ImpressumModal open={impressumOpen} onClose={() => setImpressumOpen(false)} />
      <DatenschutzModal open={datenschutzOpen} onClose={() => setDatenschutzOpen(false)} />
    </FooterSection>
  );
};

export default Footer;
